import { EngineIcon } from './EngineIcon';

/**
 * author: Simran
 * id 290CA835-F009-4630-87D3-D4515E1F5527
 * name engine
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/engine.svg
 * tags
 * - Automotive 
 */
export const MotorIcon = EngineIcon;
export default MotorIcon